import { useSearchParams } from 'react-router-dom'
import ConnectorViewForm from '../../../../components/connector_views/ConnectorViewForm'

const ConnectorViewNew = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  return (
    <ConnectorViewForm
      persisted={false}
      clone_from={searchParams.get('clone_from') ? true : false}
    />
  )
}

export default ConnectorViewNew
